import { render, staticRenderFns } from "./DocumentDownloadButton.vue?vue&type=template&id=a41bfb1a&"
import script from "./DocumentDownloadButton.vue?vue&type=script&lang=js&"
export * from "./DocumentDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports